import { IdentityAnswers } from 'merchant-api/types';
import { getCheckoutState } from 'merchant-api/checkout';
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { checkout } from '..';

interface IdentityChallengeAnswersProps {
  isErrorIdentityChallengeAnswers: any;
  identityAnswersChallengeData: any;
  sendIdentityChallengeAnswers: any;
  isLoadingIdentityChallengeAnswers: boolean;
  mutation: UseMutationResult<any, Error, IdentityAnswers>;
}

export function postIdentityChallengeAnswers(): IdentityChallengeAnswersProps {
  const queryClient = useQueryClient();
  const { checkoutData, isLoadingCheckoutState, isErrorCheckoutState } = getCheckoutState();

  const mutation = useMutation({
    mutationFn: async (arg: IdentityAnswers) => {
      const data = await checkout.post(`/v1/identity-verification/${checkoutData?.checkoutUuid}/challenge?`, arg).then((res) => res.data);
      await queryClient.invalidateQueries({
        queryKey: ['checkout'],
      });
      return data;
    },
    mutationKey: ['postIdentityChallengeAnswers', checkoutData?.checkoutUuid],
  });

  return {
    isErrorIdentityChallengeAnswers: mutation.error || isErrorCheckoutState,
    isLoadingIdentityChallengeAnswers: mutation.isPending || isLoadingCheckoutState,
    sendIdentityChallengeAnswers: mutation.mutateAsync,
    identityAnswersChallengeData: mutation.data,
    mutation,
  };
}
